/**
 * @file Snackbar-related text
 */
import { __ } from 'bits/intl'

export const SAVE_CHANGES_FAILED: { [key: string]: string } = {
  message: __("Sorry, we couldn't save your changes. Please refresh the page."),
  actionText: __('Refresh'),
  actionName: 'reloadPage',
}

export default {
  SAVE_CHANGES_FAILED,
}
